<template>
  <div class="faq-info-page">
    <div v-if="Object.keys(info).length" class="faq-info-content">
      <div class="breadcrumb">
        <span>{{ info.categoryName }}</span>
        <span class="mx-5">&gt;</span>
        <span class="breadcrumb-link" @click="handleJump">{{ info.categorySecondName }}</span>
        <template v-if="info.categoryThirdName">
          <span class="mx-5">&gt;</span>
          <span>{{ info.categoryThirdName }}</span>
        </template>
      </div>
      <div class="info-body">
        <div class="info-title">{{ info.title }}</div>
        <div class="info-content" v-html="contentHtml" @click="onContentClick"></div>
      </div>
      <div class="vote-section">
        <div class="vote-title">这条帮助是否解决了您的问题？</div>
        <div v-if="info.voteType === 0" class="vote-btns">
          <span class="vote-btn vote-yes" @click="onVoteIsUseful(1)">已解决</span>
          <span class="vote-btn vote-no" @click="onVoteIsUseful(2)">未解决</span>
        </div>
        <div v-else class="vote-result">
          <span :class="['vote-result-icon', info.voteType === 1 ? 'result-yes' : 'result-no']">
            {{ info.voteType === 1 ? '已解决' : '未解决' }}
          </span>
          谢谢您的参与
        </div>
      </div>
    </div>
    <div v-else-if="errorMsg" class="error-state">
      <van-empty :description="errorMsg" />
    </div>
  </div>
</template>
<script>
import { Dialog, ImagePreview } from 'vant'

export default {
  data() {
    return {
      info: {
        content: '',
      },
      errorMsg: '',
    }
  },
  computed: {
    contentHtml() {
      return this.info.content ? this.renderMarkdown(this.info.content) : ''
    },
  },
  watch: {
    '$route.query.id'() {
      this.queryFaqDetail()
    },
  },
  created() {
    this.ensureUuid()
    this.queryFaqDetail()
  },
  methods: {
    renderMarkdown(text) {
      let html = text
        .replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" style="max-width:100%">')
        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>')
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/\*([^*]+)\*/g, '<em>$1</em>')
        .replace(/`([^`]+)`/g, '<code>$1</code>')
      html = html.split('\n').map(line => {
        if (!line.trim()) return ''
        return `<p>${line}</p>`
      }).join('')
      return html
    },
    ensureUuid() {
      let uuid = localStorage.getItem('faq_uuid')
      if (!uuid) {
        uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          const r = Math.random() * 16 | 0
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        localStorage.setItem('faq_uuid', uuid)
      }
    },
    queryFaqDetail() {
      if (!this.$route.query.id) return
      const uuid = localStorage.getItem('faq_uuid') || ''
      this.$apis.gameProblemServer.queryDetail({
        id: this.$route.query.id,
        uuid: uuid,
      }).then(res => {
        if (res.code === 0) {
          this.info = res.data
        } else {
          this.errorMsg = res.msg
        }
      })
    },
    onContentClick(e) {
      if (e.target.tagName === 'IMG') {
        ImagePreview([e.target.src])
      }
    },
    onVoteIsUseful(type) {
      const uuid = localStorage.getItem('faq_uuid') || ''
      this.$apis.gameProblemServer.voteIsUseful({
        id: this.$route.query.id,
        uuid: uuid,
        type: type,
      }).then(res => {
        if (res.code === 0) {
          this.queryFaqDetail()
        } else {
          Dialog({ message: res.msg, confirmButtonText: '确定' })
        }
      })
    },
    handleJump() {
      this.$router.push({ path: `/commonGameProblem/faq/${this.info.categoryIdSecond}` })
    },
  },
}
</script>
<style lang="scss" scoped>
.faq-info-page {
  background: #f5f7fb;
  min-height: 100%;
}
.faq-info-content {
  background: #fff;
  margin: 24px;
  border-radius: 16px;
  overflow: hidden;
  padding: 32px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}
.breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 26px;
  color: #999;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f2f5;
  .breadcrumb-link {
    color: #5a88ff;
    font-weight: 500;
  }
  .mx-5 {
    margin: 0 10px;
    display: inline-flex;
    align-items: center;
    color: #ccc;
  }
}
.info-body {
  padding: 32px 0;
}
.info-title {
  font-size: 36px;
  font-weight: 700;
  color: #222;
  text-align: center;
  margin-bottom: 40px;
  line-height: 1.4;
}
.info-content {
  font-size: 28px;
  line-height: 1.8;
  color: #555;
  word-wrap: break-word;
  /deep/ img {
    max-width: 100%;
    border-radius: 8px;
    margin: 10px 0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  /deep/ p {
    margin-bottom: 20px;
  }
  /deep/ ol li {
    list-style: decimal;
    margin-left: 40px;
    margin-bottom: 8px;
  }
  /deep/ ul li {
    list-style: disc;
    margin-left: 40px;
    margin-bottom: 8px;
  }
  /deep/ code {
    background: #f0f2f5;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 24px;
    color: #e74c3c;
  }
}
.vote-section {
  text-align: center;
  padding-top: 40px;
  border-top: 1px solid #f0f2f5;
}
.vote-title {
  font-size: 30px;
  font-weight: 600;
  color: #333;
  margin-bottom: 32px;
}
.vote-btns {
  display: flex;
  justify-content: center;
  gap: 50px;
}
.vote-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 72px;
  border-radius: 36px;
  font-size: 28px;
  font-weight: 500;
  transition: all 0.25s;
  &:active {
    transform: scale(0.95);
  }
}
.vote-yes {
  border: 2px solid #5ae036;
  color: #5ae036;
  background: #f5fff5;
  &:active {
    background: #5ae036;
    color: #fff;
  }
}
.vote-no {
  border: 2px solid #f44646;
  color: #f44646;
  background: #fff5f5;
  &:active {
    background: #f44646;
    color: #fff;
  }
}
.vote-result {
  font-size: 28px;
  color: #999;
  padding: 16px 0;
  .vote-result-icon {
    display: inline-flex;
    align-items: center;
    margin-right: 12px;
    font-size: 28px;
    font-weight: 500;
  }
  .result-yes {
    color: #5ae036;
  }
  .result-no {
    color: #f44646;
  }
}
.error-state {
  padding-top: 160px;
}
</style>
